export default __webpack_public_path__ + "static/media/1.2e8d8860.jpeg";